#import "../fragments/sales-automation-stageset.graphql"

mutation DeleteClosedLeadTaskTemplate($taskTemplate: DeleteClosedLeadTaskTemplateInputFieldInput!) {
    deleteClosedLeadTaskTemplate(input: {taskTemplate: $taskTemplate}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
